var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.555,
    height: 19.551,
    viewBox: "0 0 30.555 19.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".discoverA{fill:#fff;}.discoverB{fill:#ef7622;}.discoverC{fill:#231f20;}.discoverD{clip-path:url(#discoverA);}.discoverE{fill:url(#discoverB);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "discoverA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.2,32.446a2.346,2.346,0,1,0,2.346-2.346,2.324,2.324,0,0,0-2.346,2.346",
    transform: "translate(-255.2 -30.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discoverB",
    x1: -166.684,
    y1: 5.788,
    x2: -166.656,
    y2: 5.788,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f59f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#f49a01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f28d04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f18406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#ef7b09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6f0d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "discoverA",
    width: 30.553,
    height: 19.547,
    transform: "translate(0.001 0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverB",
    d: "M266.461,38.9S258.194,44.765,243,47.39h23.461Z",
    transform: "translate(-236.13 -28.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M261.144,19.5H230.7V39.048h30.555V19.5Zm-.112.223v19.1H230.923v-19.1h30.109Z",
    transform: "translate(-230.7 -19.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M234.485,30.2H233.2v4.412h1.229a2.435,2.435,0,0,0,1.62-.5,2.094,2.094,0,0,0,.782-1.676,2.183,2.183,0,0,0-2.123-2.234Zm1.005,3.351a1.532,1.532,0,0,1-1.173.335h-.223v-2.96h.223a1.714,1.714,0,0,1,1.173.335,1.406,1.406,0,0,1,.5,1.117A1.443,1.443,0,0,1,235.49,33.551Z",
    transform: "translate(-231.804 -24.224)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "discoverC",
    width: 0.838,
    height: 4.412,
    transform: "translate(5.418 5.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M244.243,31.74c-.5-.168-.67-.335-.67-.559a.613.613,0,0,1,.614-.5.8.8,0,0,1,.67.335l.447-.614a1.864,1.864,0,0,0-1.285-.5,1.313,1.313,0,0,0-1.4,1.229v.056c0,.614.279.949,1.061,1.229a2.994,2.994,0,0,1,.614.279.57.57,0,0,1,.279.447.62.62,0,0,1-.614.614h-.056a1.032,1.032,0,0,1-.95-.614l-.559.559a1.735,1.735,0,0,0,1.564.838,1.432,1.432,0,0,0,1.508-1.34v-.112C245.528,32.466,245.249,32.131,244.243,31.74Z",
    transform: "translate(-235.865 -24.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M248.5,32.346a2.265,2.265,0,0,0,2.29,2.29h.056a2.31,2.31,0,0,0,1.061-.279V33.351a1.478,1.478,0,0,1-1.061.5,1.52,1.52,0,0,1-1.508-1.4v-.112a1.445,1.445,0,0,1,1.4-1.508h.056a1.3,1.3,0,0,1,1.061.5V30.279a2.264,2.264,0,0,0-3.352,2.067Z",
    transform: "translate(-238.557 -24.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M265.223,33.16,264.05,30.2h-.95l1.843,4.524h.5l1.9-4.524h-.95Z",
    transform: "translate(-245.002 -24.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M271.4,34.612h2.458v-.726h-1.62V32.713H273.8v-.782h-1.564v-.949h1.62V30.2H271.4Z",
    transform: "translate(-248.665 -24.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M279.649,31.485c0-.838-.559-1.285-1.564-1.285H276.8v4.412h.838V32.825h.112l1.173,1.787h1.061l-1.4-1.843A1.182,1.182,0,0,0,279.649,31.485Zm-1.732.782h-.279v-1.34h.279q.838,0,.838.67T277.917,32.267Z",
    transform: "translate(-251.049 -24.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M282.779,30.512c0-.056-.056-.112-.168-.112H282.5v.391h.112v-.168l.112.168h.112l-.112-.168A.2.2,0,0,0,282.779,30.512Zm-.168.056h0v-.112h0c.056,0,.056,0,.056.056S282.668,30.568,282.612,30.568Z",
    transform: "translate(-253.565 -24.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "discoverC",
    d: "M282.435,30.1a.335.335,0,1,0,.335.335h0a.322.322,0,0,0-.335-.335Zm0,.614a.279.279,0,1,1,.279-.279h0a.264.264,0,0,1-.279.279Z",
    transform: "translate(-253.389 -24.18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.685 5.92)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "discoverD"
  }, /*#__PURE__*/React.createElement("path", {
    className: "discoverE",
    d: "M260.282,31.718,256.818,26.3,251.4,29.763l3.463,5.418Z",
    transform: "translate(-253.523 -28.422)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.f56486cbfa4309ffd957d80c5a9a6675.svg";
export { ForwardRef as ReactComponent };